import React from 'react';
import { StatusIcon } from '@nearst/ui';
import { NavigationCell } from '../NavigationCell';
import styles from './Issues.module.scss';

const Issues = ({ row }) => {
	return (
		<NavigationCell barcode={row.barcode} className={styles.issuesCell}>
			<div className={styles.cell}>
				{row.issues?.length > 0 ? (
					<span className={styles.issuesContainer} data-cy="inventory-viewer-missing-data">
						<StatusIcon status="error" />
						{row.issues.length} {row.issues.length === 1 ? 'issue' : 'issues'}
					</span>
				) : null}
			</div>
		</NavigationCell>
	);
};

export { Issues };
